import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle } from "vue"
import _imports_0 from '../assets/logo.png'


const _hoisted_1 = { class: "runtime-config-overlay__panel" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 1,
  class: "runtime-config-overlay__error"
}
const _hoisted_4 = {
  key: 2,
  class: "runtime-config-overlay__gauge",
  "aria-hidden": "true"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", {
    class: "runtime-config-overlay",
    style: _normalizeStyle(_ctx.themeStyle),
    role: "status",
    "aria-live": "assertive",
    "aria-busy": "true"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "runtime-config-overlay__logo" }, [
        _createElementVNode("img", {
          src: _imports_0,
          alt: "Suite241"
        })
      ], -1)),
      _cache[4] || (_cache[4] = _createElementVNode("h1", null, "Suite241", -1)),
      (!_ctx.hasError)
        ? (_openBlock(), _createElementBlock("p", _hoisted_2, "Chargement de la configuration…"))
        : (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.errorMessage), 1)),
      (!_ctx.hasError)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [...(_cache[1] || (_cache[1] = [
            _createElementVNode("span", null, null, -1)
          ]))]))
        : (_openBlock(), _createElementBlock("button", {
            key: 3,
            type: "button",
            class: "runtime-config-overlay__retry",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.retry && _ctx.retry(...args)))
          }, [...(_cache[2] || (_cache[2] = [
            _createElementVNode("i", {
              class: "fa fa-rotate-right",
              "aria-hidden": "true"
            }, null, -1),
            _createTextVNode(" Réessayer ", -1)
          ]))]))
    ])
  ], 4))
}